<template>
  <div class="login-body">
    <div class="login-bar">
      <div class="sys-name">
        <span class="sys-icon">
          <img src="../assets/img/logo2.png" alt="" />
        </span>
        <span class="sys-title">实证分析<br />图表分析</span>
      </div>
      <div class="login-info">
        <div class="login-logo">
          <span class="">系统登录</span>
        </div>

        <div class="input-body">
          <el-input
            type="text"
            v-model="model.mobile"
            class="input-body-item"
            placeholder="账号"
            :maxlength="100"
            @keyup.enter.native="loginEvent"
          >
            <span slot="prefix" class="icon-small">
              <img src="../assets/img/icon账号.png" alt="" />
            </span>
          </el-input>
          <el-input
            type="password"
            v-model="model.password"
            class="input-body-item"
            placeholder="密码"
            :maxlength="100"
            @keyup.enter.native="loginEvent"
          >
            <span slot="prefix" class="icon-small">
              <img src="../assets/img/icon密码.png" alt="" />
            </span>
          </el-input>

          <el-button class="input-body-item login-btn" @click="loginEvent" :loading="loading">登录</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';
import { SET_USER_TOKEN } from '@/store/types';
import qs from 'qs';

export default {
  data() {
    return {
      model: {
        mobile: '',
        password: ''
      },
      loading: false
    };
  },

  components: {},

  mounted() {},

  methods: {
    async loginEvent() {
      if (!this.model.mobile) {
        this.$message({ type: 'warning', message: '请输入正确的手机号码' });
        return;
      }
      if (!this.model.password) {
        this.$message({ type: 'warning', message: '请输入正确的密码' });
        return;
      }
      try {
        this.loading = true;
        const token = await services.authriozation.login2({ name: this.model.mobile, password: this.model.password });
        this.$store.commit(SET_USER_TOKEN, token);
        await this.$store.dispatch('getUserInfo');
        await this.$store.dispatch('getOrders');
        this.loginAfterHandle();
      } catch (err) {
        this.$store.dispatch('logout', { replaceToLogin: false, sendEvent: true });
        this.$error(err);
      } finally {
        this.loading = false;
      }
    },
    loginAfterHandle() {
      const { redirect_name: redirectName = '', redirect_query: redirectQuery = '' } = this.$route.query;
      if (redirectName) {
        const query = qs.parse(decodeURIComponent(redirectQuery));
        this.$router.replace({ name: redirectName, query });
      } else {
        this.$router.replace({ name: 'home' });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.login-body {
  background: linear-gradient(45deg, #112349 0%, #184bb1 53%, #11234b 100%, #11234a 100%);
  height: 100vh;
  width: 100%;
  display: flex;

  .login-bar {
    align-self: center;
    display: flex;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;

    .sys-name {
      display: flex;

      .sys-icon {
        width: 160px;
        margin: 60px 30px;
        display: inline-block;

        img {
          width: 100%;
          display: block;
        }
      }

      .sys-title {
        margin-top: 80px;
        font-size: 55px;
        font-weight: normal;
        color: #ffffff;
        line-height: 67px;
      }
    }
  }
}

.login-info {
  width: 400px;
  height: 320px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid rgba(44, 61, 97, 0.6);

  .login-logo {
    text-align: center;
    margin: 20px auto 0 auto;
    line-height: 60px;

    .logo {
      width: 55px;

      img {
        width: 100%;
        display: block;
      }
    }
  }

  .login-btn {
    background: #2483fe;
    width: 100%;
    color: #fff;
    border-color: #2483fe;
  }

  .input-body {
    margin: 20px 25px 0 25px;

    .input-body-item {
      margin-bottom: 20px;
    }

    .icon-small {
      margin-top: 11px;
      margin-left: 3px;
    }
  }
}
</style>
